export default {
  name: "wine-add-cart-btn",
  props: {
    loading: Boolean,
    click: Function,
    isStockIncompatible: {
      type: Boolean,
      default: false
    }
  }
};